import React from "react";
import { EmbeddedContent } from "@origin-digital/tal-fe";
import { usePrefetched } from "../prefetch";

export const Footer = () => {
  const footerPrefetch = usePrefetched("tal_footer");
  if (!footerPrefetch?.content) return null;
  const content = footerPrefetch.content.includes("<")
    ? footerPrefetch.content
    : // TalCore.version < 1.32.0 has the content base64 encoded. Decode it here if we detect it is still encoded.
      // If you see this code on master, talcore 1.32.0 has gone to prod, so you can remove this
      Buffer.from(footerPrefetch.content, "base64").toString("binary");

  return (
    <EmbeddedContent
      content={content}
      useShadowDom={footerPrefetch.EXPERIMENTAL_shadowFooter}
    />
  );
};
